import { css } from "@emotion/css";

// Center the 340px waveform over the 226px card: (340 - 226) / 2 = 57px.
export const waveformOffsetClass = css({ position: "relative", left: "-57px" });
